import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { hide, show } from '../../actions/ActivityIndicatorAction';
import {
  fetchAnamoliesReport,
  fetchAssetHourlyData,
  fetchDailyReport,
  fetchEEHourlyFeederLog,
  fetchEnergyLossReport,
  fetchFaultData,
  fetchFrequencyList,
  fetchPeakDemandReport,
  fetchReliabilityIndices,
  fetchReport24x7operation,
  fetchReportCircuitBreaker,
  fetchReportDetails,
  fetchReportHighActivityBreaker,
  fetchReportLimitVoilation,
  fetchReportCustomizedPQ,
  fetchReportCustomizedPDS,
  fetchReportSaidiSaifi,
  fetchReportsList,
  fetchRolesApiDataByUser,
  fetchRolesByRoleId,
  fetchTransformerLossReport,
  fetchVoilationsReport,
  fetchReportRTUHealth,
  fetchSubstationDailylog,
  fetchReportEventLogSoE,
  session,
  fetchSampleData,
  fetchReportForAssetDailyCountData,
  fetchProductDataStreamInterval,
  fetchReportAlarmlog,
  fetchReportEquipmentBreakDown,
  fetchReportCBoperation,
  fetchReportForLoadPriorityTable,
  fetchReportADS,
  fetchReportOilWindTap,
} from '../../Service/APIService';
import {
  JSONToCSVConvertorNew,
  JSONToPDFConvertor,
  JSONToXLSConvertor,
  JSONToXLSXConvertor,
} from '../../shared/CommanFunction';
import { constants } from '../../shared/constants';
import { showToast } from '../../utils/helper';
import Header from '../AssetHealthApp/Header';
import Breadcrumb from '../Custom/Breadcrumb';
import SelectBox from '../Custom/SelectBox';

import '../../contents/css/freezeTable.css';
import TableComponent from './TableComponent';

const date = new Date();
const year = date.getFullYear();

const arrMinutes = [1, 5, 10, 15, 30, 60].map((item) => ({
  val: parseInt(item, 10),
}));

const arrDays = _.map(_.range(1, 32), (item) => ({
  val: _.padStart(item, 2, '0'),
}));
const arrMonths = _.map(moment.months(), (item, index) => ({
  name: `${item} (${_.padStart(index + 1, 2, '0')})`,
  val: _.padStart(index + 1, 2, '0'),
}));
const arrWeeks = _.map(_.range(1, 53), (item) => ({
  val: _.padStart(item, 2, '0'),
}));
const arrQuerterly = [
  { name: 'Jan - Mar', val: '01' },
  { name: 'Apr - Jun', val: '02' },
  { name: 'Jul - Sep', val: '03' },
  { name: 'Oct - Dec', val: '04' },
];
const arrYear = _.map(_.range(year - 1, year + 1), (item) => ({ val: item }));
const arrFinYearly = _.map(_.range(year - 1, year + 2), (item) => ({
  val: item,
  name: `01 Apr ${item - 1} - 31 Mar ${item}`,
}));

const styles = {
  overflowX: 'auto',
  maxHeight: '300px',
  marginTop: '20px',
  marginBottom: '20px',
  backgroundColor: '#fff',
};
class PFCReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      levels: constants.default.EMPTY_ARRAY,
      clientHirarchey: constants.default.EMPTY_ARRAY,
      reportsList: constants.default.EMPTY_ARRAY,
      frequencyList: constants.default.EMPTY_ARRAY,
      reportsMetaData: constants.default.EMPTY_ARRAY,
      FrequencyListIds: constants.default.EMPTY_STRING,
      mdlClientHirarchy: constants.default.EMPTY_STRING,
      mdlReport: constants.default.EMPTY_STRING,
      mdlReportType: constants.default.EMPTY_STRING,
      mdlFrequency: constants.default.EMPTY_STRING,
      mdlMinutes: constants.default.EMPTY_STRING,
      mdlDays: constants.default.EMPTY_STRING,
      mdlWeek: constants.default.EMPTY_STRING,
      mdlMonths: constants.default.EMPTY_STRING,
      mdlQuerterly: constants.default.EMPTY_STRING,
      mdlYear: constants.default.EMPTY_STRING,
      VoltageCurrent: constants.default.EMPTY_STRING,
      mdlSingleDate: constants.default.EMPTY_STRING,
      mdlDateRange: constants.default.EMPTY_STRING,
      mdlFinYear: constants.default.EMPTY_STRING,
      hirarchyName: constants.default.EMPTY_STRING,
      mdlClientHirarchyName: constants.default.EMPTY_STRING,
      data: constants.default.EMPTY_ARRAY,
      excludeMomentaryFaults: constants.default.EMPTY_BOOL,
      mdlLimit: 5,
      breadCrumbName: constants.default.EMPTY_STRING,
      selectedOption: 'PDF',
    };
    this.selectInputRef = React.createRef();
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  componentDidMount() {
    this.fetchLevels();
  }

  onClear = () => {
    if (this.state.hirarchyName === 'Asset')
      this.selectInputRef.current.select.setValue('');
    else this.selectInputRef.current.select.clearValue();
  };

  renderTable = (arrData) => (
    <table
      id="frzTable"
      className="table freeze-table"
      style={{ border: '1px solid #ddd' }}
    >
      <thead>
        <tr>{this.renderHeading(arrData)}</tr>
      </thead>
      <tbody>{this.renderRows(arrData)}</tbody>
    </table>
  );

  renderHeading = (arrData) =>
    _.map(_.keys(arrData[0]), (item, index) => (
      <th
        className="fixed-header"
        key={`th-${index}`}
        style={{
          minWidth: '100px',
          paddingTop: '12px',
          paddingBottom: '12px',
          textAlign: 'left',
          backgroundColor: '#4CAF50',
          color: 'white',
          paddingLeft: '6px',
        }}
      >
        {' '}
        {item}
      </th>
    ));

  renderRows = (arrData) =>
    _.map(arrData, (c, index) => (
      <tr key={`tr-${index}`} style={{ border: '1px solid #ddd' }}>
        {_.map(c, (val, index1) => (
          <td key={`td-${index1}`} style={{ fontSize: '12px' }}>
            {!_.isNil(val) ? val : ''}
          </td>
        ))}
      </tr>
    ));

  render() {
    const {
      levels,
      clientHirarchey,
      reportsList,
      frequencyList,
      reportsMetaData,
      mdlReport,
      mdlFrequency,
      mdlReportType,
      hirarchyName,
      mdlLimit,
      breadCrumbName,
    } = this.state;
    const userInfo = session.user();

    let tableHeadingData = [];
    let tableContentData = [];
    if (this.state.data) {
      const data = [...this.state.data];
      tableHeadingData = data.shift();
      tableContentData = data;
    }
    return (
      <>
        <Header BrandText={'Report Export'} />
        <>
          <Col lg={12} className={'pt-5 justify-content-md-center'}>
            <Breadcrumb
              breadCrumbName={breadCrumbName}
              style={{ padding: '5px', marginLeft: '5px' }}
            />
            <Row>
              <Col lg={3}>
                <label className="control-label">Select Level</label>
                <Select
                  options={levels.map((x) => ({
                    label: x.levelName,
                    value: x.roleId,
                  }))}
                  onChange={this.fetchClientHirarchy}
                />
              </Col>
              <Col lg={3}>
                <label className="control-label">{`Select ${hirarchyName}`}</label>
                <Select
                  ref={this.selectInputRef}
                  options={clientHirarchey.map((item) => ({
                    value: item.value,
                    label: item.text,
                  }))}
                  name="mdlClientHirarchy"
                  isMulti={this.state.hirarchyName !== 'Asset'}
                  onChange={(selectedOptions) =>
                    this.onHirarchyChange(selectedOptions, clientHirarchey)
                  }
                />
              </Col>
              <Col lg={3}>
                <SelectBox
                  data={reportsList}
                  val={'ReportId'}
                  text={'ReportName'}
                  name={'mdlReport'}
                  label={'Select Report Name'}
                  onChange={this.onReportChange}
                />
              </Col>
              <Col lg={3}>
                <SelectBox
                  data={reportsMetaData}
                  val={'name'}
                  text={'name'}
                  selected={mdlReportType}
                  name={'mdlReportType'}
                  label={'Select Report Type'}
                  onChange={(e) =>
                    this.setState({
                      [e.target.name]: e.target.value,
                      data: constants.default.EMPTY_STRING,
                    })
                  }
                />

                {mdlReport === '4' &&
                  mdlReportType === constants.reportType.HISTORIC && (
                    <>
                      <div className="form-group">
                        <input
                          type="radio"
                          name="VoltageCurrent"
                          value="Voltage"
                          onChange={(e) =>
                            this.setState({
                              [e.target.name]: e.target.value,
                              data: constants.default.EMPTY_STRING,
                            })
                          }
                        />
                        &nbsp;Voltage&nbsp;&nbsp;&nbsp;
                        <input
                          type="radio"
                          name="VoltageCurrent"
                          value="Current"
                          onChange={(e) =>
                            this.setState({
                              [e.target.name]: e.target.value,
                              data: constants.default.EMPTY_STRING,
                            })
                          }
                        />
                        &nbsp;Current
                      </div>
                    </>
                  )}
              </Col>
            </Row>

            {mdlReport === '9' && (
              <Col lg={3}>
                <div className="form-group">
                  <label className="control-label">Limit</label>
                  <input
                    type="text"
                    className="form-control"
                    name="mdlLimit"
                    value={mdlLimit}
                    onChange={(e) =>
                      this.setState({
                        [e.target.name]: e.target.value,
                        data: constants.default.EMPTY_STRING,
                      })
                    }
                  />
                </div>
              </Col>
            )}
            {mdlReportType === constants.reportType.HISTORIC && (
              <>
                <Col lg={3}>
                  <SelectBox
                    data={frequencyList}
                    val={'ReportFrequencyListId'}
                    text={'DisplayText'}
                    name={'mdlFrequency'}
                    label={'Select Frequency'}
                    onChange={(e) =>
                      this.setState({
                        [e.target.name]: e.target.value,
                        data: constants.default.EMPTY_STRING,
                      })
                    }
                  />
                </Col>
                {mdlFrequency === '1' && (
                  <Col lg={3}>
                    <SelectBox
                      data={arrDays}
                      val={'val'}
                      text={'val'}
                      name={'mdlDays'}
                      label={'Select Day'}
                      onChange={(e) =>
                        this.setState({
                          [e.target.name]: e.target.value,
                          data: constants.default.EMPTY_STRING,
                        })
                      }
                    />
                  </Col>
                )}
                {mdlFrequency === '9' && (
                  <Col lg={3}>
                    <SelectBox
                      data={arrWeeks}
                      val={'val'}
                      text={'val'}
                      name={'mdlWeek'}
                      label={'Select Week'}
                      onChange={(e) =>
                        this.setState({
                          [e.target.name]: e.target.value,
                          data: constants.default.EMPTY_STRING,
                        })
                      }
                    />
                  </Col>
                )}
                {_.includes(['1', '2'], mdlFrequency) && (
                  <Col lg={3}>
                    <SelectBox
                      data={arrMonths}
                      val={'val'}
                      text={'name'}
                      name={'mdlMonths'}
                      label={'Select Month'}
                      onChange={(e) =>
                        this.setState({
                          [e.target.name]: e.target.value,
                          data: constants.default.EMPTY_STRING,
                        })
                      }
                    />
                  </Col>
                )}
                {mdlFrequency === '3' && (
                  <Col lg={3}>
                    <SelectBox
                      data={arrQuerterly}
                      val={'val'}
                      text={'name'}
                      name={'mdlQuerterly'}
                      label={'Select Quarter'}
                      onChange={(e) =>
                        this.setState({
                          [e.target.name]: e.target.value,
                          data: constants.default.EMPTY_STRING,
                        })
                      }
                    />
                  </Col>
                )}
                {_.includes(['1', '2', '3', '9'], mdlFrequency) && (
                  <Col lg={3}>
                    <SelectBox
                      data={arrYear}
                      val={'val'}
                      text={'val'}
                      name={'mdlYear'}
                      label={'Select Year'}
                      onChange={(e) =>
                        this.setState({
                          [e.target.name]: e.target.value,
                          data: constants.default.EMPTY_STRING,
                        })
                      }
                    />
                  </Col>
                )}

                {mdlFrequency === '4' && (
                  <Col lg={3}>
                    <SelectBox
                      data={arrFinYearly}
                      val={'val'}
                      text={'name'}
                      name={'mdlFinYear'}
                      label={'Select Financial Year'}
                      onChange={(e) =>
                        this.setState({
                          [e.target.name]: e.target.value,
                          data: constants.default.EMPTY_STRING,
                        })
                      }
                    />
                  </Col>
                )}

                {_.includes(['6', '7'], mdlFrequency) && (
                  <Col lg={3}>
                    <div className="form-group">
                      <label className="control-label">Select From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="mdlSingleDate"
                        onChange={(e) =>
                          this.setState({
                            [e.target.name]: e.target.value,
                            data: constants.default.EMPTY_STRING,
                          })
                        }
                      />
                    </div>
                  </Col>
                )}

                {mdlFrequency === '6' && (
                  <Col lg={3}>
                    <div className="form-group">
                      <label className="control-label">Select To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="mdlDateRange"
                        onChange={(e) =>
                          this.setState({
                            [e.target.name]: e.target.value,
                            data: constants.default.EMPTY_STRING,
                          })
                        }
                      />
                    </div>
                  </Col>
                )}
                {(_.includes(
                  ['1', '2', '3', '4', '6', '7', '9'],
                  mdlFrequency
                ) &&
                  mdlReport === '37' &&
                  userInfo?.showGDSData) ||
                  ((mdlReport === '31' || mdlReport === '32') && (
                    <Col lg={3}>
                      <SelectBox
                        data={arrMinutes}
                        val={'val'}
                        text={'val'}
                        name={'mdlMinutes'}
                        label={'Select Sample Time'}
                        onChange={(e) =>
                          this.setState({
                            [e.target.name]: e.target.value,
                            data: constants.default.EMPTY_STRING,
                          })
                        }
                      />
                    </Col>
                  ))}
              </>
            )}
            <Col lg={12}>
              {mdlReport === '1' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '5px',
                  }}
                >
                  <label className="switch">
                    <input
                      name="excludeMomentaryFaults"
                      value={this.state.excludeMomentaryFaults}
                      type="checkbox"
                      onChange={(e) =>
                        this.setState({
                          [e.target.name]: e.target.value === 'false',
                          data: constants.default.EMPTY_STRING,
                        })
                      }
                    />
                    <span className="slider round"></span>
                  </label>{' '}
                  &nbsp;
                  <span>Exclude Momentary Faults</span>
                </div>
              )}
            </Col>
            <Col lg={12} style={{ textAlign: 'right' }} className="pull-right">
              <button
                className="btn btn-sm btn-success"
                type="button"
                disabled={this.validate()}
                onClick={() => this.onSubmitButtonClick('TABLE')}
              >
                Show Data
              </button>
              &nbsp;
              <select
                id="ddlPCX"
                disabled={this.validate()}
                className="btn btn-sm btn-success"
                value={this.state.selectedOption}
                onChange={this.handleOptionChange}
              >
                <option value="PDF">PDF</option>
                <option value="XLSX">XLSX</option>
                <option value="XLS">XLS</option>
                <option value="CSV">CSV</option>
              </select>
              &nbsp;
              <button
                className="btn btn-sm btn-success"
                type="button"
                disabled={this.validate()}
                onClick={() =>
                  this.onSubmitButtonClick(this.state.selectedOption)
                }
              >
                Download
              </button>{' '}
              &nbsp;
            </Col>
            <Col lg={10} lgOffset={1} style={{ marginBottom: '100px' }}>
              {this.state.data.length > 0 && (
                <>
                  <div style={styles}>{this.renderTable(tableHeadingData)}</div>
                  {tableContentData &&
                    _.map(tableContentData, (data) => (
                      <>
                        <TableComponent data={data} /> <br></br>{' '}
                      </>
                    ))}
                </>
              )}
            </Col>
          </Col>
        </>
      </>
    );
  }
  handleOptionChange = (event) => {
    this.setState({ selectedOption: event.target.value });
  };
  onHirarchyChange = (selectedOption, clientHirarchey) => {
    if (selectedOption.length !== 0) {
      let selected = '';
      if (this.state.hirarchyName !== 'Asset') {
        selected = _.map(
          selectedOption,
          (item) =>
            _.find(clientHirarchey, { value: item.value }).breadCrumbName
        );
      } else if (!selectedOption)
        selected = [
          _.find(clientHirarchey, { value: selectedOption?.value })
            ?.breadCrumbName,
        ];

      const tmpFinalString = [];
      const tmpInitialString = [];
      _.forEach(selected, (item) => {
        const items = item?.split('>');
        if (items?.length > 1) {
          tmpFinalString.push(items[items.length - 1]);
          items.splice(-1, 1); // remove last elements
          tmpInitialString.push(items.join(' > '));
        } else {
          tmpFinalString.push(items ? items[0] : '');
        }
      });
      const first = _.uniq(tmpInitialString);
      const concatinatedString =
        first.length > 0 &&
        _.toString(first).concat(' > ').concat(tmpFinalString.join(' | '));
      const breadCrumbName = _.toString(concatinatedString || '');
      const mdlClientHirarchy =
        this.state.hirarchyName === 'Asset'
          ? [selectedOption].map((x) => x.value).join(',')
          : selectedOption.map((x) => x.value).join(',');
      const mdlClientHirarchyName =
        this.state.hirarchyName === 'Asset'
          ? [selectedOption].map((x) => x.label).join(',')
          : selectedOption.map((x) => x.label).join(',');
      this.setState({
        mdlClientHirarchy,
        mdlClientHirarchyName,
        data: constants.default.EMPTY_STRING,
        breadCrumbName,
      });
    }
  };

  // 1st ddl
  fetchLevels = async () => {
    const { roleId } = session.user();
    fetchRolesByRoleId(roleId)
      .then((res) => {
        this.setState({
          levels: res.data.statusCode === 200 ? res.data.result : [],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  fetchClientHirarchy = async (selectedRole) => {
    const { levelName } = this.state.levels.find(
      (role) => role.roleId === selectedRole.value
    );
    this.fetchReportsList(selectedRole.value);
    const { memberId, roleId } = session.user();
    const obj =
      roleId === 1
        ? { id: session.client(), type: 'byClient' }
        : { id: memberId, type: 'byUser' };
    const roleName = _.replace(_.lowerCase(levelName), ' ', '');

    fetchRolesApiDataByUser(
      obj.type,
      roleName,
      obj.id,
      constants.core.APPS.REPORT_EXPORT
    )
      .then(async (res) => {
        if (res.data.statusCode === 200) {
          const arr = _.get(res.data, 'result');
          const clientHirarchey = _.map(arr, (c) => ({
            value: c.displayId,
            text: c.displayName,
            level: levelName,
            breadCrumbName: c.breadCrumbName,
            assetType: [2, 5].includes(Number(c.assetTypeId))
              ? 'TRANSFORMER'
              : 'FEEDER',
          }));
          this.setState({
            clientHirarchey,
            hirarchyName: levelName,
            mdlClientHirarchy: '',
            mdlClientHirarchyName: '',
          });
        }
      })
      .catch((err) => console.log(err))
      .finally(this.onClear());
  };

  fetchReportsList = (levelId) => {
    const clientId = session.client();
    fetchReportsList(levelId, clientId)
      .then((res) => {
        const { result, statusCode } = res.data;
        this.setState({
          reportsList: statusCode === 200 ? result.reports : [],
        });
      })
      .catch((err) => console.log(err));
  };

  fetchFrequencyList = () => {
    fetchFrequencyList()
      .then((res) => {
        if (res.data.statusCode === 200) {
          const AllowsListIds = _.split(this.state.FrequencyListIds, ',');
          const frequencyList = _.filter(res.data.result.frequency, (freq) =>
            _.includes(AllowsListIds, freq.ReportFrequencyListId.toString())
          );
          this.setState({ frequencyList });
        } else {
          this.setState({ frequencyList: [] });
        }
      })
      .catch((err) => console.log(err));
  };

  onReportChange = (e) => {
    const { name, value } = e.target;
    fetchReportDetails(value)
      .then((res) => {
        if (res.data.statusCode === 200) {
          const {
            result: { Historic, RealTime, ReportFrequencyListIds },
          } = res.data;
          const reportsMetaData = [];
          if (Historic === 1) {
            reportsMetaData.push({ name: constants.reportType.HISTORIC });
          }
          if (RealTime === 1) {
            reportsMetaData.push({ name: constants.reportType.REALTIME });
          }

          this.setState(
            {
              [name]: value,
              mdlReportType:
                reportsMetaData.length === 1
                  ? reportsMetaData[0].name
                  : constants.default.EMPTY_STRING,
              reportsMetaData,
              FrequencyListIds: ReportFrequencyListIds,
              data: constants.default.EMPTY_STRING,
            },
            () => this.fetchFrequencyList()
          );
        } else {
          this.setState(
            {
              reportsList1: [],
              FrequencyListIds: constants.default.EMPTY_STRING,
            },
            () => this.fetchFrequencyList()
          );
        }
      })
      .catch((err) => console.log(err));
  };

  replaceKeys = (originalArray, alternateNamesArray) => {
    const newArray = originalArray.map((originalObject) => {
      const newObject = {};

      Object.keys(originalObject).forEach((originalKey) => {
        const alternateName = alternateNamesArray[originalKey];
        const newKey = alternateName || originalKey;
        if (originalObject[originalKey] !== null) {
          newObject[newKey] = originalObject[originalKey];
        }
      });

      return newObject;
    });

    return newArray;
  };

  fetchReport = async (type, obj) => {
    let isTransformer = false;
    if (obj.level === 'Asset') {
      isTransformer =
        _.find(this.state.clientHirarchey, { value: Number(obj.levelId) })
          .assetType === 'TRANSFORMER';
    }
    switch (type) {
      case 'SAIDI_SAIFI':
        return fetchReportSaidiSaifi(obj);
      case 'ALARM_LOG':
        return fetchReportAlarmlog(obj);
      case 'EQUIPMENT_BREAKDOWN':
        return fetchReportEquipmentBreakDown(obj);
      case 'Oil_Wind_Tap Report':
        return fetchReportOilWindTap(obj);
      case 'ads':
        return fetchReportADS(obj);
      case 'SWITCHING_MONITOR':
        return fetchReportCBoperation(obj);
      case 'EVENT_LOG':
        return fetchReportEventLogSoE(
          obj.frequency,
          `${obj.level}/${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'LIMIT_VIOLATION':
        return fetchReportLimitVoilation(obj);
      case 'USER_LOGIN':
        return fetchReport24x7operation(obj);
      case 'CB_TRIPPING':
        return fetchReportCircuitBreaker(obj);
      case 'HIGH_ACTIVITY_BREAKER':
        return fetchReportHighActivityBreaker(obj);
      case 'EE_DAILY_FEEDER_DATA': // EE-DailyFeederData
        return fetchDailyReport(
          isTransformer,
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'EE_HOURLY_FEEDER_LOG': // EE-HourlyFeederLog Sheet
        return fetchEEHourlyFeederLog(
          isTransformer,
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'FAULT_DATA': // faultdata
        return fetchFaultData(
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'RELIABILITY_INDICES': // Reliability Indices
        // eslint-disable-next-line no-case-declarations
        const dt = obj.frequencyValue.split('|');
        return fetchReliabilityIndices({
          levelTyp: obj.level,
          id: obj.levelId,
          startDt: dt.length > 0 && dt[0],
          endDt: dt.length > 1 ? dt[1] : dt[0],
          freqType: 'daily',
        });
      case 'ASSET_HOURLY_LOG_SHEET': // asset - hourlylogsheet
        return fetchAssetHourlyData(
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'SS_ENERGY_LOSS': // SS EnergyLoss Report
        return fetchEnergyLossReport(
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'SS_TRANSFORMER_LOSS': // SS TransformerLoss Report
        return fetchTransformerLossReport(
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'ASSET_VIOLATION_REPORT': // Asset Violation Report
        return fetchVoilationsReport(
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'PEAK_DEMAND_REPORT': // PeakDemand Report
        return fetchPeakDemandReport(
          obj.frequency,
          `${obj.level}/${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'ANOMALIES_REPORT': // Anomalies Report
        return fetchAnamoliesReport(
          obj.frequency,
          `${obj.level}/${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
      case 'RTU_HEALTH':
        return fetchReportRTUHealth(obj);
      case 'PQ':
        return fetchReportCustomizedPQ(obj);
      case 'PDS':
        return fetchReportCustomizedPDS(obj);
      case 'GDSDataSingleDateBySampleTime': {
        const sampleData = await fetchSampleData(
          obj.frequency,
          `${obj.levelId}/${obj.frequencyValue.replace('|', '/')}`
        );
        if (sampleData.data.result[1] && sampleData.data.result[2]) {
          let obj = [];
          obj[0] = sampleData.data.result[0];
          obj[1] = await this.replaceKeys(
            sampleData.data.result[1],
            sampleData.data.result[2][0]
          );
          return {
            ...sampleData,
            data: { ...sampleData.data, result: obj },
          };
        }
        return sampleData;
      }
      case 'ASSET_DAILY_COUNT_RECORD': {
        const [startDateTime, endDateTime = startDateTime] =
          obj.frequencyValue.split('|');
        const [startDt, interval] = startDateTime.split('/');
        const [endDt, interval2] = endDateTime.split('/');

        return fetchReportForAssetDailyCountData(
          `${obj.levelId}/${startDt}/${endDt}/${interval || interval2}`
        );
      }
      case 'PRODUCT_DATA_STREAM_INT': {
        const [startDateTime, endDateTime = startDateTime] =
          obj.frequencyValue.split('|');
        const [startDt, interval] = startDateTime.split('/');
        const [endDt, interval2] = endDateTime.split('/');

        return fetchProductDataStreamInterval(
          `${obj.levelId}/${startDt}/${endDt}/${interval || interval2}`
        );
      }
      case 'LOAD_PRIORITY_TABLE': {
        const [startDateTime, endDateTime = startDateTime] =
          obj.frequencyValue.split('|');
        const [startDt] = startDateTime.split('/');
        const [endDt] = endDateTime.split('/');

        return fetchReportForLoadPriorityTable(
          obj.level,
          `${obj.levelId}/${startDt}/${endDt}`
        );
      }
      case 'SS_DAILY_LOG_SHEET': {
        const [startDateTime] = obj.frequencyValue.split('|');
        const [startDt] = startDateTime.split('/');

        return fetchSubstationDailylog(
          obj.level,
          `${obj.levelId}/${startDt}`
        );
      }
      default:
        return null;
    }
  };

  validate = () => {
    const { mdlClientHirarchy, mdlReport, mdlReportType, mdlFrequency } =
      this.state;
    return (
      _.isEqual(mdlClientHirarchy, constants.default.EMPTY_STRING) ||
      _.isEqual(mdlReport, constants.default.EMPTY_STRING) ||
      _.isEqual(mdlReportType, constants.default.EMPTY_STRING) ||
      this.checkFreqType(mdlReportType, mdlFrequency) ||
      this.getFreq()
    );
  };

  checkFreqType = (mdlReportType, mdlFrequency) => {
    if (_.isEqual(mdlReportType, constants.reportType.REALTIME)) {
      return false;
    }
    return _.isEqual(mdlFrequency, constants.default.EMPTY_STRING);
  };

  getFreq = () => {
    const {
      mdlFrequency,
      mdlMonths,
      mdlQuerterly,
      mdlYear,
      mdlSingleDate,
      mdlDateRange,
      mdlFinYear,
    } = this.state;

    switch (mdlFrequency) {
      case '2':
        return (
          _.isEqual(mdlMonths, constants.default.EMPTY_STRING) ||
          _.isEqual(mdlYear, constants.default.EMPTY_STRING)
        );
      case '3':
        return (
          _.isEqual(mdlQuerterly, constants.default.EMPTY_STRING) ||
          _.isEqual(mdlYear, constants.default.EMPTY_STRING)
        );
      case '4':
        return _.isEqual(mdlFinYear, constants.default.EMPTY_STRING);
      case '6':
        return (
          _.isEqual(mdlSingleDate, constants.default.EMPTY_STRING) ||
          _.isEqual(mdlDateRange, constants.default.EMPTY_STRING)
        );
      default:
        break;
    }
    return false;
  };

  onSubmitButtonClick = async (type) => {
    const {
      mdlClientHirarchy,
      mdlReport,
      reportsList,
      mdlReportType,
      VoltageCurrent,
      mdlFrequency,
      frequencyList,
      clientHirarchey,
      mdlClientHirarchyName,
      excludeMomentaryFaults,
      mdlLimit,
    } = this.state;

    const selectedReport = _.find(
      reportsList,
      (x) => x.ReportId === Number(mdlReport)
    );
    let obj = {
      level: clientHirarchey.find(
        (x) => x.value === Number(mdlClientHirarchy.split(',')[0])
      ).level, // _.replace(sessionObj.role, 'Admin', ''),
      levelId: mdlClientHirarchy, // Number(mdlClientHirarchy),
      id: Number(mdlReport),
      name: selectedReport.ReportName,
      type: mdlReportType,
      isVoltageViolation:
        VoltageCurrent === constants.electricityType.VOLTAGE || false,
      frequency:
        mdlReportType !== constants.reportType.REALTIME
          ? _.find(
            frequencyList,
            (x) => x.ReportFrequencyListId === Number(mdlFrequency)
          )?.DisplayText.replace(' ', '')
          : constants.core.EMPTY_MSG,
      // eslint-disable-next-line no-nested-ternary
      frequencyValue:
        mdlReportType !== constants.reportType.REALTIME
          ? mdlFrequency
            ? this.fetchFreqValue(mdlFrequency)
            : 0
          : 0,
    };
    this.props.show();

    if (mdlReport === '1') {
      obj = { ...obj, excludeMomentaryFaults };
    }
    if (mdlReport === '9') {
      obj = { ...obj, thresholdLimit: mdlLimit };
    }
    // eslint-disable-next-line no-nested-ternary
    this.fetchReport(selectedReport.ReportKey, obj)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.result.length) {
            if (_.isNil(res.data.result[1]) || !res.data.result[1].length) {
              showToast(constants.core.NO_DATA_MSG, constants.toast.ERROR);
              this.props.hide();
              return false;
            }
            const hrchyName = mdlClientHirarchyName.replace(' ', '_');
            const rptName = obj.name
              .replace(' ', '_')
              .replace(',', '')
              .replace(',', '/');
            const freq = obj.frequency.replace(' ', '_');
            const fileName = `${hrchyName}_${rptName}_${obj.type}_${freq}`;
            const reportHeader = {
              header:
                'Level: ' +
                obj.level +
                ' - ' +
                clientHirarchey.find(
                  (x) => x.value === Number(mdlClientHirarchy.split(',')[0])
                ).text +
                '\n Report Name: ' +
                obj.name +
                '\n Report Type: ' +
                obj.type +
                '\n Frequency: ' +
                obj.frequency,
              frequencyValue: obj.frequencyValue,
            };

            if (_.isEqual(type, 'CSV')) {
              this.downoadCSV(res.data.result, fileName);
              showToast(constants.core.REPORT_SUCCESS_MSG);
            } else if (_.isEqual(type, 'PDF')) {
              this.downoadPDF(res.data.result, fileName, reportHeader);
              showToast(constants.core.REPORT_SUCCESS_MSG);
            } else if (_.isEqual(type, 'XLSX')) {
              this.downoadXLSX(res.data.result, fileName);
              showToast(constants.core.REPORT_SUCCESS_MSG);
            } else if (_.isEqual(type, 'XLS')) {
              this.downoadXLS(res.data.result, fileName);
              showToast(constants.core.REPORT_SUCCESS_MSG);
            } else {
              this.setState({ data: res.data.result });
            }
          } else {
            this.setState({ data: [] });
            showToast(constants.core.NO_DATA_MSG, constants.toast.ERROR);
          }
        }
      })
      .catch((err) => {
        this.setState({ data: [] });
        showToast(constants.core.SOMETHING_WENT_WRONG, constants.toast.ERROR);
        console.log(err);
      })
      .finally(() => {
        this.props.hide();
      });
  };
  downoadPDF = (data, fileName, reportHeader) => {
    JSONToPDFConvertor(data, fileName, reportHeader);
  };
  downoadCSV = (data, fileName) => {
    JSONToCSVConvertorNew(data, fileName, true);
  };
  downoadXLSX = (data, fileName) => {
    JSONToXLSXConvertor(data, fileName);
  };
  downoadXLS = (data, fileName) => {
    JSONToXLSConvertor(data, fileName);
  };
  fetchFreqValue = (type) => {
    const {
      mdlDays,
      mdlMonths,
      mdlYear,
      mdlWeek,
      mdlQuerterly,
      mdlSingleDate,
      mdlDateRange,
      mdlFinYear,
      mdlMinutes,
    } = this.state;
    switch (Number(type)) {
      case 1:
        return `${mdlYear}${mdlMonths}${mdlDays}`;
      case 2:
        return `${mdlYear}${mdlMonths}`;
      case 3:
        return `${mdlYear}${mdlQuerterly}`;
      case 4:
        return mdlFinYear;
      case 5:
        return constants.core.EMPTY_MSG;
      case 9:
        return `${mdlYear}${mdlWeek}`;
      case 6:
        return `${mdlSingleDate}|${mdlDateRange}${
          mdlMinutes ? '/' + mdlMinutes : ''
          }`;
      case 7:
        return `${mdlSingleDate}${mdlMinutes ? '/' + mdlMinutes : ''}`;

      default:
        return constants.core.EMPTY_MSG;
    }
  };
}
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      hide,
      show,
    },
    dispatch
  );

const PFCReportContainer = connect(null, mapDispatchToProps)(PFCReport);

PFCReport.propTypes = {
  show: PropTypes.func,
  hide: PropTypes.func,
};

export default PFCReportContainer;
